package top.wcpe.allincore.ui.runtime.ir.api

import kotlin.jvm.JvmField

/** v4 client DSL 内建作用域对象。 */
class ClientApi(
    world: WorldApi? = null,
    options: OptionsApi? = null,
    input: InputApi? = null,
    snapshotFlag: Boolean = false,
) {
    private val world: WorldApi = world ?: WorldApi.NOOP
    private val options: OptionsApi = options ?: OptionsApi.NOOP
    private val input: InputApi = input ?: InputApi.NOOP
    private val snapshotFlag: Boolean = snapshotFlag

    constructor(world: WorldApi) : this(world, null, null)

    fun world(): WorldApi = world
    fun options(): OptionsApi = options
    fun input(): InputApi = input

    /** 当前客户端是否运行在快照版（对齐原版 Minecraft.isSnapshot()）。 */
    fun isSnapshot(): Boolean = snapshotFlag

    companion object {
        @JvmField val NOOP: ClientApi = ClientApi(WorldApi.NOOP, OptionsApi.NOOP, InputApi.NOOP)
    }
}

/** v4 client.input DSL 作用域：按键绑定查询/修改。 */
interface InputApi {
    fun allBindings(): List<Map<String, Any>>
    fun getKey(id: String): String
    fun setKey(id: String, glfwKeyName: String)
    fun conflicts(id: String): List<String>
    fun getLabel(id: String): String
    fun getCategory(id: String): String
    fun isUnbound(id: String): Boolean
    fun resetAllKeys()
    fun save()

    companion object {
        @JvmField val NOOP: InputApi = object : InputApi {
            override fun allBindings(): List<Map<String, Any>> = emptyList()
            override fun getKey(id: String): String = ""
            override fun setKey(id: String, glfwKeyName: String) {}
            override fun conflicts(id: String): List<String> = emptyList()
            override fun getLabel(id: String): String = ""
            override fun getCategory(id: String): String = ""
            override fun isUnbound(id: String): Boolean = true
            override fun resetAllKeys() {}
            override fun save() {}
        }
    }
}

/** DSL 中 vanilla 内建对象：原版资源路径 helper。 */
class VanillaApi private constructor() {
    companion object {
        @JvmField val NOOP: VanillaApi = VanillaApi()

        @Deprecated("Use NOOP")
        @JvmField
        val INSTANCE: VanillaApi = NOOP
        private const val WIDGETS = "minecraft:textures/gui/widgets.png"
        private const val ICONS = "minecraft:textures/gui/icons.png"
    }

    fun container(name: String?): String = "minecraft:textures/gui/container/${name ?: ""}.png"
    fun widgets(): String = WIDGETS
    fun icons(): String = ICONS
    fun path(relative: String?): String = "minecraft:${relative ?: ""}"

    @Deprecated("Use container")
    fun gui(name: String?): String = container(name)
}

/** v4 client.world DSL 作用域对象。 */
class WorldApi(source: WorldDataSource? = null) {
    private val source: WorldDataSource = source ?: WorldDataSource.NOOP

    fun posX(): Double = source.posX()
    fun posY(): Double = source.posY()
    fun posZ(): Double = source.posZ()
    fun yaw(): Double = source.yaw()
    fun dimension(): String = source.dimension()
    fun tiles(radius: Int): List<Number> = source.tiles(radius)
    fun entities(radius: Int): List<Map<String, Any>> = source.entities(radius)
    fun isSingleplayer(): Boolean = source.isSingleplayer()
    fun isPublished(): Boolean = source.isPublished()
    fun isLocalServer(): Boolean = source.isLocalServer()

    companion object {
        @JvmField val NOOP: WorldApi = WorldApi(WorldDataSource.NOOP)
    }
}
